import type { AgentDto } from '@/types/gtm-agents';

/** The server owns the ten-play limit; this mirrors it in Add controls. */
export const MAX_AGENT_PLAYS = 10;

/** A named owned play, or the sole play. Plural and foreign targets stay unset. */
export function selectedAgentPlay(
  agent: Pick<AgentDto, 'playIds'> | undefined,
  named?: string
): string | undefined {
  if (!agent) return undefined;
  if (named) return agent.playIds.includes(named) ? named : undefined;
  return agent.playIds.length === 1 ? agent.playIds[0] : undefined;
}

/** A new returned attachment is safe to edit only when its identity is unique. */
export function addedAgentPlay(
  before: Pick<AgentDto, 'id' | 'organizationId' | 'playIds'>,
  after: AgentDto,
  attached?: string
): string | undefined {
  if (before.id !== after.id || before.organizationId !== after.organizationId)
    return undefined;
  if (attached)
    return !before.playIds.includes(attached) &&
      after.playIds.includes(attached)
      ? attached
      : undefined;
  const added = after.playIds.filter((id) => !before.playIds.includes(id));
  return added.length === 1 ? added[0] : undefined;
}
